module.exports = __webpack_public_path__ + "static/media/wheel-icon.5c1b07ba.png";